export enum COMPETITIONS_ADD_TABS {
    awards = 'awards',
    cgwave = 'cgwave',
    rules = 'rules',
    jury = 'jury',
    figurine = 'figurine',
    competitions = 'competitions',
    cgravecontests = 'cgravecontests'
}export enum COMPETITIONS_ADD_TABS {
    awards = 'awards',
    cgwave = 'cgwave',
    rules = 'rules',
    jury = 'jury',
    figurine = 'figurine',
    competitions = 'competitions',
    cgravecontests = 'cgravecontests'
}